import { render, staticRenderFns } from "./PropertySearchField.vue?vue&type=template&id=22670c5c"
import script from "./PropertySearchField.vue?vue&type=script&lang=ts"
export * from "./PropertySearchField.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports